//@ts-check
import { h } from "common/dom-builder";
import { smallIconButton } from "common/icon-buttons";

const minLineHeight = 90;
const maxLineHeight = 200;

export class LineHeightControl {
  /**
   * @param {{typeTester: import("../TypeTester").TypeTester, element: HTMLElement}} props
   */
  constructor(props) {
    this.props = props;
    this.init();
  }

  init() {
    const { format } = this.props.typeTester.props;
    this.value = format.lineHeight ?? Math.max(120, minLineHeight);
    this.render();
    this.updateControlWhenLineHeightChanges();

    this.props.typeTester.props.fontStyle.minLineHeightAscender;
  }

  get initialValue() {
    return this.props.typeTester.props.format.lineHeight;
  }

  render() {
    this.element = h(
      "div",
      {
        class: [
          "control",
          "line-height-control",
          "with-icon-in-front",
          "tool-panel",
          "with-value-indicator",
        ],
        style: `--value-indicator-max-digits: ${Math.max(
          Math.ceil(maxLineHeight).toString().length,
          Math.floor(minLineHeight).toString().length
        )};`,
      },
      [
        smallIconButton("spacing-vertical"),
        this.buildInput(),
        // this.renderValueIndicator(),
      ]
    );
    // this.change(this.value); // removed to avoid #flakycontenthtml
    return this.element;
  }

  updateControlWhenLineHeightChanges() {
    this.props.typeTester.addEventListener("change", (ev) => {
      if (ev.detail.format.lineHeight === undefined) return;
      if (ev.detail.format.lineHeight === this.value) return;
      this.handleChange(ev.detail.format.lineHeight);
    });
  }

  // Value changed by this control
  change(height) {
    this.value = height;
    this.props.typeTester.textEditor.setLineHeight(height);
    if (this.valueIndicatorElement) {
      this.valueIndicatorElement.textContent = height;
    }
  }

  // Value changed by another control
  handleChange(height) {
    this.value = height;
    this.inputElement.value = height;
    if (this.valueIndicatorElement) {
      this.valueIndicatorElement.textContent = height;
    }
  }

  buildInput() {
    const inputElement = (this.inputElement = h("custom-range-slider", {
      min: minLineHeight,
      max: maxLineHeight,
      step: 1,
      value: this.value,
    }));
    inputElement.addEventListener("input", (ev) => {
      this.change(ev.target.value);
    });
    inputElement.addEventListener("change", (ev) => {
      this.change(ev.target.value);
      this.props.typeTester.element.dispatchEvent(
        new CustomEvent("interaction")
      );
    });
    this.props.typeTester.addEventListener("reset", () => {
      inputElement.value = this.value;
    });
    return inputElement;
  }

  renderValueIndicator() {
    return (this.valueIndicatorElement = h(
      "span",
      { class: ["value-indicator", "tabular-numbers"] },
      [`${this.initialValue}`]
    ));
  }
}
